import { LI, UL } from "../../../../../AbstractElements";
import SvgIcon from "../../../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { Website } from "../../../../../Utils/Constants";

const InvoiceRightSide = () => {
  return (
    <UL style={{ listStyle: "none", display: "flex", background: "linear-gradient(291deg, #6f5a99 21.2%, #6f5a99 83.92%)", padding: "31px 80px", borderBottomLeftRadius: 100, gap: 28 }} className="flex-row" >
      <LI className="p-0" style={{ display: "flex", alignItems: "center", background: "none" , border:"none"}}>
        <SvgIcon className="stroke-icon" iconId="call" style={{ height: 14, width: 14, fill: "#fff", marginRight: 10 }} />
        <span style={{ color: "#FFFFFF" }}>(239) 555-0108</span>
      </LI>
      <LI style={{ borderBottom: "0" , borderLeft: "1px dashed rgba(255, 255, 255, 0.3)", borderRight: "1px dashed rgba(255, 255, 255, 0.3)", padding: "0 22px", display: "flex", alignItems: "center", background: "none" ,}} >
        <SvgIcon className="stroke-icon" style={{ height: 16, width: 16, fill: "#fff", marginRight: 10 }} iconId="email-box" />
        <span style={{ color: "#FFFFFF" }}>Lagos@themesforest.com</span>
      </LI>
      <LI className="p-0" style={{ display: "flex", alignItems: "center",background: "none" , border:"none"}}>
        <SvgIcon className="stroke-icon" style={{ height: 16, width: 16, fill: "#fff", marginRight: 10 }} iconId="web" />
        <span style={{ color: "#FFFFFF" }}>{Website}: www.Lagosthemes.com</span>
      </LI>
    </UL>
  );
};

export default InvoiceRightSide;
